import React from 'react';
import { Typography, Card, Divider } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const BusinessTermsPage = () => {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <ShopOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ marginTop: 16 }}>
            Όροι και Προϋποθέσεις Προβολής Επιχειρήσεων
          </Title>
          <Text type="secondary">Τελευταία ενημέρωση: 30/04/2026</Text>
        </div>

        <Title level={4}>ΕΙΣΑΓΩΓΗ</Title>
        <Paragraph>
          Η ιστοσελίδα animap.gr και η σχετική διαδικτυακή πλατφόρμα της animap (εφεξής συνολικά η «ιστοσελίδα» ή ο «ιστότοπος») δημιουργήθηκε και τελεί υπό τη διαχείριση της εταιρείας «Monovia Ι.Κ.Ε.», με αρ. ΓΕΜΗ: 186347801000 και ΑΦΜ: 802964751, η οποία εδρεύει στην Αθήνα, οδός Δώρου αρ. 2, 10431 (εφεξής η «animap», «εμείς» «εμάς», «μας») και συνιστά μια διαδικτυακή πλατφόρμα αφιερωμένη στα ζώα, μέσω της οποίας οι χρήστες της έχουν τη δυνατότητα να αναζητήσουν και να επιλέξουν τον επαγγελματία που ταιριάζει καλύτερα στις ανάγκες τους, να κλείσουν ραντεβού μαζί του, καθώς και να πραγματοποιήσουν παραγγελίες προϊόντων από συνεργαζόμενα pet-shops και συναφή καταστήματα.
        </Paragraph>
        <Paragraph>
          Το παρόν κείμενο (εφεξής η «Συμφωνία») περιλαμβάνει όλους τους όρους και προϋποθέσεις που διέπουν τις σχέσεις ανάμεσα στην animap και σε εσάς (εφεξής ο «Επαγγελματίας/Έμπορος», «εσείς», «εσάς», «σας») αναφορικά με την προβολή σας στον ιστότοπο, την προβολή των υπηρεσιών σας ή/και την πώληση των προϊόντων σας μέσω του ιστοτόπου.
        </Paragraph>
        <Paragraph>
          Παρακαλούμε διαβάστε προσεκτικά την παρούσα Συμφωνία και τη <Link to="/privacy">Δήλωση Προστασίας Προσωπικών Δεδομένων</Link>, πριν ξεκινήσετε να χρησιμοποιείτε τον ιστότοπο ως Επαγγελματίας/Έμπορος. Η εγγραφή σας στην ιστοσελίδα και η χρήση των λειτουργιών αυτής ως Επαγγελματίας/Έμπορος συνεπάγεται την εκ μέρους σας ανεπιφύλακτη αποδοχή της παρούσας Συμφωνίας και της Δήλωσης Προστασίας Προσωπικών Δεδομένων του ιστοτόπου, όπως κάθε φορά ισχύουν.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΓΓΡΑΦΗ ΕΠΑΓΓΕΛΜΑΤΙΑ/ΕΜΠΟΡΟΥ</Title>
        <Paragraph>
          Μόνο οι εγγεγραμμένοι Επαγγελματίες/Έμποροι έχουν τη δυνατότητα να κάνουν χρήση των υπηρεσιών προβολής και προώθησης της animap. Κάθε Επαγγελματίας/Έμπορος που επιθυμεί να εγγραφεί στον ιστότοπο δημιουργεί τον επαγγελματικό του λογαριασμό του καταρχήν δωρεάν, συμπληρώνοντας τα απαραίτητα στοιχεία που θα του ζητηθούν.
        </Paragraph>
        <Paragraph>
          Εφόσον ο Επαγγελματίας/Έμπορος επιθυμεί να έχει πρόσβαση σε περισσότερες λειτουργικότητες και προνόμια (π.χ. προνομιακή κατάταξη στον ιστότοπο), έχει τη δυνατότητα να αγοράσει κάποια από τα διαθέσιμα συνδρομητικά πακέτα, καταβάλλοντας το σχετικό αντίτιμο της συνδρομής.
        </Paragraph>
        <Paragraph>
          Το συνδρομητικό πακέτο στο οποίο έχει εγγραφεί ο Επαγγελματίας/Έμπορος θα ανανεώνεται αυτόματα, για ισόχρονο διάστημα κάθε φορά, εκτός εάν ο Επαγγελματίας/Έμπορος επιλέξει μέσα από το λογαριασμό του την ακύρωσή του, τουλάχιστον μέχρι το πέρας της εκάστοτε ημερομηνίας λήξης του.
        </Paragraph>
        <Paragraph>
          Κατά την εγγραφή του, ο Επαγγελματίας/Έμπορος θα πρέπει επίσης να καταχωρήσει τον τραπεζικό του λογαριασμό στον οποίο θα καταβάλλονται οι αμοιβές του, ο οποίος θα διασυνδεθεί με το περιβάλλον του παρόχου ηλεκτρονικών πληρωμών Stripe Inc.
        </Paragraph>

        <Divider />

        <Title level={4}>ΔΙΚΑΙΟΛΟΓΗΤΙΚΑ ΚΑΙ ΕΠΑΛΗΘΕΥΣΗ</Title>
        <Paragraph>
          Πριν την ολοκλήρωση της διαδικασίας εγγραφής, θα ζητηθούν από τον Επαγγελματία/Έμπορο συγκεκριμένα δικαιολογητικά, ανάλογα με την ειδικότητά του, τα οποία πιστοποιούν την εμπειρία, την εξειδίκευση ή/και την άδεια του Επαγγελματία/Εμπόρου να παρέχει τις υπηρεσίες του ή/και τα προϊόντα του.
        </Paragraph>
        <Paragraph>
          Η animap διατηρεί τη δυνατότητα, κατά απόλυτη διακριτική της ευχέρεια, να απορρίψει ή να ακυρώσει την εγγραφή κάποιου Επαγγελματία/Εμπόρου στον ιστότοπο, εφόσον, κατά την εύλογη κρίση της, θεωρήσει ότι ο Επαγγελματίας/Έμπορος δεν πληροί τις προϋποθέσεις εγγραφής του ή/και δεν δύναται να παρέχει τις δηλωθείσες υπηρεσίες ή/και να πωλεί τα προϊόντα του.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΠΑΓΓΕΛΜΑΤΙΚΟ ΠΡΟΦΙΛ</Title>
        <Paragraph>
          Με την ολοκλήρωση της εγγραφής του, ο Επαγγελματίας/Έμπορος θα έχει τη δυνατότητα να δημιουργήσει το επαγγελματικό του προφίλ, μέσα από το οποίο θα δύναται να επεξεργάζεται τα στοιχεία της επιχείρησής του, τις πληροφορίες των υπηρεσιών που προσφέρει, να ενημερώνει τη λίστα, τις τιμές και τη διαθεσιμότητα των προϊόντων του, τις ημέρες και ώρες διαθεσιμότητάς του, καθώς και να αναρτά και επικαιροποιεί το προωθητικό του υλικό (κείμενα, λογότυπα, φωτογραφίες, βίντεο, προσφορές, hyperlinks κ.α.).
        </Paragraph>
        <Paragraph>
          Ο Επαγγελματίας/Έμπορος είναι απολύτως υπεύθυνος για την διατήρηση της ασφάλειας των προσωπικών του κωδικών πρόσβασης και την εν γένει ασφάλεια του λογαριασμού του, καθίσταται πλήρως υπεύθυνος για οποιαδήποτε πράξη ή ενέργεια πραγματοποιηθεί στον λογαριασμό ή μέσω αυτού και η animap αποποιείται κάθε σχετικής ευθύνης.
        </Paragraph>

        <Divider />

        <Title level={4}>ΟΙΚΟΝΟΜΙΚΟΙ ΟΡΟΙ</Title>
        <Paragraph>
          Η εγγραφή του Επαγγελματία/Εμπόρου στην ιστοσελίδα και η πρόσβαση στις παρεχόμενες υπηρεσίες πραγματοποιείται καταρχήν δωρεάν, εκτός εάν ο Επαγγελματίας/Έμπορος επιλέξει κάποιο προνομιακό συνδρομητικό πακέτο.
        </Paragraph>
        <Paragraph>
          Η animap χρεώνει μόνο μια προμήθεια επί κάθε συναλλαγής που πραγματοποιείται μέσω του ιστοτόπου (κλείσιμο ραντεβού ή πώληση προϊόντων) για τις ενδιάμεσες υπηρεσίες καταχώρησης, προώθησης και διασύνδεσης των χρηστών που παρέχει μέσω του ιστοτόπου. Η προμήθεια αυτή επιβαρύνει αποκλειστικά τον Επαγγελματία/Έμπορο και παρακρατείται από το αντίτιμο που η animap εισπράττει από τους χρήστες της για κάθε συναλλαγή, πριν το αποδώσει στον Επαγγελματία/Έμπορο.
        </Paragraph>

        <Divider />

        <Title level={4}>ΠΛΗΡΩΜΕΣ ΚΑΙ ΑΠΟΔΟΣΗ</Title>
        <Paragraph>
          Όλες οι πληρωμές για συναλλαγές που πραγματοποιούνται μέσω του ιστοτόπου διεκπεραιώνονται μέσω τρίτου αδειοδοτημένου παρόχου χρηματοοικονομικών υπηρεσιών και υπηρεσιών πληρωμών (Stripe Inc.) με τον οποίο συνεργαζόμαστε και ο οποίος παρέχει όλα τα απαραίτητα εχέγγυα ασφάλειας των ηλεκτρονικών συναλλαγών.
        </Paragraph>
        <Paragraph>
          Η απόδοση του αντιτίμου της κάθε συναλλαγής στον Επαγγελματία/Έμπορο, αφαιρούμενης της προμήθειας της animap, θα πιστώνεται στον τραπεζικό λογαριασμό που έχει δηλώσει ο Επαγγελματίας/Έμπορος εντός τριάντα (30) ημερών από την ημερομηνία πραγματοποίησης της συναλλαγής.
        </Paragraph>

        <Divider />

        <Title level={4}>ΠΟΣΟΣΤΟ ΠΡΟΜΗΘΕΙΑΣ</Title>
        <Paragraph>
          Το ύψος της προμήθειας που οφείλεται στην animap ορίζεται σε: <Text strong>25% (+Φ.Π.Α.)</Text> επί του ποσού της κάθε συναλλαγής, εκτός εάν συμφωνηθεί ειδικώς διαφορετικά μεταξύ της animap και του Επαγγελματία/Εμπόρου.
        </Paragraph>
        <Paragraph>
          Εναλλακτικά, κατά την αποκλειστική κρίση του, ο Επαγγελματίας/Έμπορος έχει τη δυνατότητα, είτε κατά την εγγραφή του στην ιστοσελίδα, είτε σε μεταγενέστερο χρόνο, να επιλέξει την υπαγωγή του στο συνδρομητικό πακέτο "Pro", με την καταβολή μηνιαίας αμοιβής στην animap. Στην περίπτωση αυτή, το ύψος της προμήθειας ανά συναλλαγή θα διαμορφώνεται σε <Text strong>15% (+ΦΠΑ)</Text> επί του ποσού της κάθε συναλλαγής.
        </Paragraph>
        <Paragraph>
          Ο Επαγγελματίας/Έμπορος θα έχει ανά πάσα στιγμή το δικαίωμα να διακόψει το καθεστώς της μηνιαίας καταβολής αμοιβής μέσα από το λογαριασμό του ή με σχετική έγγραφη ειδοποίηση προς την animap.
        </Paragraph>

        <Divider />

        <Title level={4}>ΑΝΑΠΡΟΣΑΡΜΟΓΗ ΤΙΜΩΝ</Title>
        <Paragraph>
          Η animap διατηρεί σε κάθε περίπτωση το δικαίωμα να αυξάνει μονομερώς το ποσό της προμήθειας ή/και της μηνιαίας αμοιβής της, με προηγούμενη έγγραφη ειδοποίηση τριάντα (30) ημερών προς τον Έμπορο/Επαγγελματία.
        </Paragraph>
        <Paragraph>
          Σε περίπτωση που ο τελευταίος δεν συμφωνεί με την αναπροσαρμογή, οφείλει να το δηλώσει εγγράφως προς την animap εντός δέκα (10) ημερών από την κοινοποίηση της ενημέρωσης, οπότε και η παρούσα Συμφωνία θα καταγγέλλεται αυτόματα.
        </Paragraph>

        <Divider />

        <Title level={4}>ΡΑΝΤΕΒΟΥ ΚΑΙ ΑΚΥΡΩΣΕΙΣ</Title>
        <Paragraph>
          Ο Επαγγελματίας/Έμπορος αναγνωρίζει και αποδέχεται ότι οι χρήστες της ιστοσελίδας έχουν τη δυνατότητα να αναβάλουν ή να ακυρώσουν ένα επιβεβαιωμένο ραντεβού έως και είκοσι τέσσερις (24) ώρες πριν την συμφωνηθείσα ώρα του ραντεβού, αποκλειστικά μέσω της ιστοσελίδας.
        </Paragraph>
        <Paragraph>
          Σε περίπτωση έγκαιρης ακύρωσης με τον ως άνω τρόπο, η animap θα επιστρέφει το ποσό που έχει λάβει στο χρήστη, οπότε και ο Επαγγελματίας/Έμπορος δεν θα έχει κάποια αξίωση επί αυτού. Σε τέτοια περίπτωση, δεν θα χρεώνεται κάποια προμήθεια από την animap στον Επαγγελματία/Έμπορο.
        </Paragraph>
        <Paragraph>
          Σε περίπτωση που ο χρήστης δεν ακυρώσει έγκαιρα ή δεν εμφανιστεί στο ραντεβού του με τον Επαγγελματία/Έμπορο χωρίς καμία προηγούμενη ακύρωση, το ποσό θα είναι κανονικά καταβλητέο στον Επαγγελματία/Έμπορο.
        </Paragraph>

        <Divider />

        <Title level={4}>ΕΠΙΚΟΙΝΩΝΙΑ</Title>
        <Paragraph>
          Για ερωτήσεις σχετικά με την παρούσα Συμφωνία, επικοινωνήστε μαζί μας:
        </Paragraph>
        <Paragraph>
          Email: <a href="mailto:legal@animap.gr">legal@animap.gr</a><br />
          Διεύθυνση: Δώρου 2, 10431 Αθήνα
        </Paragraph>

        <Divider />

        <Paragraph type="secondary" style={{ textAlign: 'center' }}>
          Δείτε επίσης: <Link to="/terms">Όροι Χρήσης</Link> | <Link to="/privacy">Πολιτική Απορρήτου</Link> | <Link to="/cookies">Πολιτική Cookies</Link>
        </Paragraph>
      </Card>
    </div>
  );
};

export default BusinessTermsPage;
